import {
  defineComponent, type PropType, type Ref, ref,
} from 'vue'
import moment, { type Moment } from 'moment'
import { type CalendarDay, useCalendar, useCalendarTemplate } from '../composables'

import './calendar.sass'

export default defineComponent({
  props: {
    disablePastDates: {
      type: Boolean,
      default: false,
    },

    date: {
      type: Object as PropType<Moment | null>,
      required: true,
    },
    onSetDate: {
      type: Function as PropType<(date: Moment) => void>,
      required: true,
    },
  },

  setup(props) {
    const selectedDate: Ref<Moment> = ref(moment(props.date))
    const calendar = useCalendar(props.date || moment(), { disablePastDates: props.disablePastDates })
    const todayDate = moment().format('DD-MM-YYYY')

    const setDate = (date: Moment) => {
      selectedDate.value = moment(date)

      if (props.onSetDate) {
        props.onSetDate(moment(date))
      }
    }

    const formatDaysForCalendar = (day: CalendarDay) => {
      const cls = []

      if (day.faded || day.disabled) {
        cls.push('faded')
      }

      if (day.date.isSame(selectedDate.value, 'day')) {
        cls.push('selected')
      }

      if (todayDate === day.date.format('DD-MM-YYYY')) {
        cls.push('today')
      }

      return (
        <div onClick={() => { if (!day.disabled) setDate(day.date) }} class={`ark-ui-calendar-day ${cls.join(' ')}`}>
          <div class="ark-ui-calendar-day-border">
            { day.date.format('D') }
          </div>
        </div>
      )
    }

    return () => {
      const days = calendar.days.value.map(formatDaysForCalendar)

      return useCalendarTemplate(calendar, days)
    }
  },
})
